import { push } from "connected-react-router";
import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { mapUrlToFormDataSetter } from "../router/utilities";

export const useSubmitForm: (
  currentPage: string,
  nextPage?: string
) => (data: any) => false | undefined = (
  currentPage: string,
  nextPage?: string
) => {
  const dispatch = useDispatch();

  return useCallback(
    (data: any) => {
      const redirect = nextPage || data?.redirect;

      //JIRA LPPLWEBMOB-721
      if (!data?.redirect) {
        alert(
          "Wystapil blad wysylki danych - skontaktuj sie z administratorem"
        );
        console.log(
          "GIELK - Blad useCallback, sprawdz czy wszystkie zmienne JS zawieraja dane."
        );

        return false;
      }

      const formDataSetter = mapUrlToFormDataSetter[currentPage];

      if (formDataSetter) {
        dispatch(formDataSetter(data));
      }

      dispatch(push(redirect));
    },
    [currentPage, nextPage, dispatch]
  );
};
